<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" :class="!isDetail && 'isDetail'" v-html="svg"></div>
</template>

<script setup lang="tsx">
import { ref } from 'vue';

const props = withDefaults(
  defineProps<{ isDetail?: boolean; pageNo?: string }>(),
  {
    isDetail: false,
    pageNo: '01'
  }
);

const svg = ref(`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 131 61.394">
    <g id="yema9" transform="translate(-82 -378)">
      <rect id="矩形_2887" data-name="矩形 2887" width="131" height="13" transform="translate(82 426.394)" fill="var(--theme-color-1)"/>
      <text id="_01" data-name="01" transform="translate(82 412)" fill="var(--theme-color-1)" font-size="32" font-weight="600"><tspan x="0" y="0">${props.pageNo}</tspan></text>
    </g>
  </svg>
`);
</script>
<style lang="scss" scoped>
@import './index.scss';
.isDetail {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
</style>
